module.exports = __webpack_public_path__ + "static/media/94aa531e-7746-4df0-bb6e-349891f2eda5.fd862f58.woff2";